import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'

export default {
  ...cloneDeep(baseDefaults),
  variant: 'thin',
  dividerColor: 'var(--color-primary)',
  textColor: 'var(--color-primary)',
  maxWidth: {
    desktop: {
      value: 100, unit: '%'
    } 
  },
  verticalPadding: { 
    desktop: {
      value: 16, unit: 'px'
    },
  },
  withText: false,
  text: 'divider text',
  styles: {
    desktop: {
      root: {
        default: {
          spacing: {
            padding: {
              top: 40,
              bottom: 40,
              left: 0,
              right: 0,
              unit: 'px'
            }
          }
        }
      }
    }
    // styles desktop wrapper default padding 
  }
}
